import Vue from 'vue'
import Router from 'vue-router'
// import Auth from './components/Auth.vue'
// import AuthSuccess from './components/AuthSuccess.vue'
import Preview from './views/Preview.vue'
import Options from './views/Options.vue'
import Home from './views/Home.vue'
import Tos from './views/Tos.vue'
import Register from './views/Register.vue'
import History from './views/History.vue'
import Test from './views/Test.vue'
import Add from './views/Add.vue'
import Users from './views/Users.vue'
import AuthGuard from './router/auth-guard'
import Dev from './views/Dev.vue'
// import Discord from './components/Discord.vue'
import {store} from './store'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
  {
    path: '/options',
    name: 'options',
    component: Options,
    beforeEnter: (to, from, next)=> {
      if(store.state.company.subscribed){
        next()
      } else {
        next('/')
      }
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  }, 
  {
    path: '/tos',
    name: 'tos',
    component: Tos
  },
  // {
  //   path: '/Discord',
  //   name: 'Discord',
  //   component: Discord
  //     // beforeEnter: AuthGuard
  //   },
    {
      path: '/history',
      name: 'history',
      component: History,
      beforeEnter: (to, from, next)=> {
        if(store.state.company.subscribed){
          next()
        } else {
          next('/')
        }
      }
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      beforeEnter: (to, from, next)=> {
        if(!store.state.company.subscribed){
          next()
        } else {
          next('/options')
        }
      }
    },
    {
      path: '/preview',
      name: 'preview',
      component: Preview,
      beforeEnter: (to, from, next)=> {
        if(Object.keys(store.state.preview).length >= 1){
          next()
        } else {
          next('/history')
        }
      }
    },
    {
      path: '/add',
      name: 'add',
      component: Add,
      beforeEnter: (to, from, next)=> {
        if(store.state.company.subscribed){
          next()
        } else {
          next('/')
        }
      }
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      beforeEnter: (to, from, next)=> {
        if(store.state.company.subscribed && store.state.user.admin){
          next()
        } else {
          next('/options')
        }
      }
    },
    {
      path: '/dev',
      name: 'dev',
      component: Dev,
    }

    ]
  })
